import { Form as SUIForm, type FormProps } from 'semantic-ui-react';

import { FormEnterProvider } from './form-enter-context';

export interface EnhancedFormProps extends FormProps {
  /**
   * When provided, `FieldInput` descendants will call this handler when the
   * user presses Enter. Use this to wire form submission or step advancement
   * to the Enter key without per-input event handling.
   *
   * Should be a stable reference (e.g. wrapped in `useCallback`) to avoid
   * unnecessary re-renders.
   */
  onEnterSubmit?: () => void;
}

/**
 * Thin wrapper around SUI `Form` that sets `noValidate` by default to
 * disable native HTML5 validation in favour of schema-driven validation.
 *
 * When `onEnterSubmit` is provided, it is exposed via context so that
 * `FieldInput` descendants can automatically bind Enter-to-submit behavior.
 */
const FormBase = ({ onEnterSubmit, ...props }: EnhancedFormProps) => (
  <FormEnterProvider value={onEnterSubmit ?? null}>
    <SUIForm noValidate {...props} />
  </FormEnterProvider>
);

export const Form = Object.assign(FormBase, {
  Field: SUIForm.Field,
  Group: SUIForm.Group,
});

export default Form;
